var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { g as gsapWithCSS } from "./_arrow.js?var=20250416";
import { S as Splide, c as conf, G as Grid } from "./splide-extension-grid.esm.js?var=11";
import { s as setReviewStars } from "./_index.js?var=15";
const kv = document.querySelector(".kv");
const KV = () => {
  mainSlider$1();
};
const mainSlider$1 = () => {
  const slider2 = kv.querySelector(".js-slider");
  const slide = new Splide(slider2, {
    type: "loop",
    start: 0,
    rewind: true,
    speed: 880,
    arrows: true,
    pagination: true,
    autoplay: true, // true
    interval: 4e3,
    slideFocus: false,
    pauseOnHover: false,
    fixedWidth: 1760,
    height: 920, 
    updateOnMove: true,
    drag: true,
    rewindByDrag: false,
    pauseOnHover: false,
    keyboard: true,
    wheel: false,
    cover: true, //true,
    padding: {
      right: "calc((100% - 1760px) /2)",
      left:  "calc((100% - 1760px) /2)"
    },
    breakpoints: {
      [conf.MQ_DOWN.lg]: {
        fixedWidth: "100%",
        height: "52.3vw",
      },
      [conf.MQ_DOWN.xxl]: {
        fixedWidth: "100%",
        height: "52.3vw",
      },
      [conf.MQ_DOWN.md]: {
        fixedWidth: "100%",
        height: "155.6vw", /* 142.6*/
        arrows: false
      },
      [conf.MQ_DOWN.sm]: {
        fixedWidth: "100%",
        height: "152.6vw", /* 142.6*/
        arrows: false
      }      
            
    }
  });
  slide.on("pagination:mounted", function (data) {
    data.items.forEach(function (item) {
      item.li.classList.add("paginationWrapper");
      item.button.classList.add("paginationButton");
      item.button.innerHTML = `<svg width="6" height="6" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="5" height="5" rx="2.5" fill="white" stroke="#D9D9D9"/>
      </svg>
      `;
    });
  });
  slide.on("moved", function () {
    const nextSlide = document.querySelector(".splide__slide.is-active");
    //const barLink = document.querySelector(".kv__barLink");
    //barLink.href = nextSlide.dataset.url;
  });
  slide.mount();
};
const topics = document.querySelector(".topics");
const TOPICS = () => {
  slider();
};
const slider = () => {
  const slider2 = topics.querySelector(".js-slider");
  const slide = new Splide(slider2, {
    type: "loop",
    speed: 680,
    arrows: true,
    pagination: true,
    autoplay: false,
    perPage: 4,
    perMove: 4,
    fixedWidth: "18.80vw",
    slideFocus: false,
    pauseOnHover: true,
    drag: true,
    rewindByDrag: true,
    pauseOnHover: true,
    keyboard: true,
    wheel: false,
    // clones: 3,
    cloneStatus: false,
    width: "1945px"
  });
  slide.on("pagination:mounted", function (data) {
    data.items.forEach(function (item) {
      item.li.classList.add("paginationWrapper");
      item.button.classList.add("paginationButton");
      item.button.innerHTML = `<svg width="6" height="6" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="6" height="6" rx="3.5" fill="white" stroke="#D9D9D9"/>
      </svg>
      `;
    });
  });
  slide.mount();
};
const brand = document.querySelector(".brand");
const SLIDE_SPEED = 1.28;
const SP_SLIDE_SPEED = 0.72;
const DELAY = 6;
let nowAnimation = null;
const mainSlider = () => {
  const slider2 = brand.querySelector(".js-slider");
  const slide = new Splide(slider2, {
  //  start: 3,  /* add. not top kinotoya. */
    type: "loop",
    speed: SLIDE_SPEED * 1e3,
    arrows: true,
    pagination: false,
    autoplay: false,
    interval: DELAY * 1e3,
    slideFocus: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    drag: true,
    rewindByDrag: false,
    updateOnMove: true,
    pauseOnHover: false,
    keyboard: false,
    wheel: false,
    height: "563px",
    fixedWidth: 1150,
    padding: {
      left: "calc(50% - 890px)",
      right: "calc(50% - 890px)"
    },
    // fixedWidth: 1150,
    breakpoints: {
      [conf.MQ_DOWN.xxl]: {
        fixedWidth: 1150,
        height: "32vw",
        padding: {
          left: 0
        }
      },
      [conf.MQ_DOWN.md]: {
        speed: SP_SLIDE_SPEED * 1e3,
        fixedWidth: "100%",
        height: "122.67vw",
        padding: {
          left: 0
        }
      }
    }
  });
  const PC_ICON_SIZE = `4.2vw`;
  const SP_ICON_SIZE = `10.67vw`;
  const nav = new Splide(brand.querySelector(".js-pageNation"), {
  //  start: 3,  /* add. not top kinotoya. */
    type: "loop",
    speed: SLIDE_SPEED * 1e3,
    arrows: false,
    pagination: false,
    width: "505px",
    fixedWidth: "73px",
    fixedHeight: "74px",
    gap: 12,
    perPage: 8,
    updateOnMove: true,
    isNavigation: true,
    updateOnMove: true,
    slideFocus: false,
    pauseOnHover: false,
    drag: true,
    focus: 3,
    rewindByDrag: false,
    pauseOnHover: false,
    keyboard: true,
    wheel: false,
    cloneStatus: false,
    breakpoints: {
      [conf.MQ_DOWN.xxl]: {
        width: `29.2vw`,
        fixedWidth: PC_ICON_SIZE,
        fixedHeight: PC_ICON_SIZE,
        gap: `0.83vw`,
        width: `35vw`,
        focus: 3
      },
      [conf.MQ_DOWN.md]: {
        speed: SP_SLIDE_SPEED * 1e3,
        width: "76.1vw",
        height: SP_ICON_SIZE,
        fixedWidth: SP_ICON_SIZE,
        fixedHeight: SP_ICON_SIZE,
        padding: `0 0 0 5.33vw`,
        gap: `2.4vw`,
        focus: 2
      }
    }
  });
  nav.on("active", function () {
    startPathAnimation();
  });
  slide.sync(nav);
  slide.mount();
  nav.mount();
  setPathAnimation();
  startPathAnimation();
};
const startPathAnimation = () => {
  const activeSlide = document.querySelector(".js-pageNation .is-active");
  if (nowAnimation) {
    nowAnimation.animation.kill();
    gsapWithCSS.set(nowAnimation.path, {
      "stroke-dasharray": nowAnimation.pathLength,
      "stroke-dashoffset": nowAnimation.pathLength
    });
  }
  nowAnimation = pathAnimation(activeSlide);
};
const pathAnimation = (el) => {
  const path = el.querySelector("path");
  const pathLength = path.getTotalLength();
  const animation = gsapWithCSS.to(path, {
    "stroke-dashoffset": 0,
    duration: DELAY,
    ease: "none",
    onComplete: () => {
      gsapWithCSS.set(path, {
        "stroke-dasharray": pathLength,
        "stroke-dashoffset": pathLength
      });
    }
  });
  animation.play();
  return {
    animation,
    path,
    pathLength
  };
};
const setPathAnimation = () => {
  const pageNation = brand.querySelectorAll(".js-pageNationItem");
  pageNation.forEach((el) => {
    const path = el.querySelector("path");
    const pathLength = path.getTotalLength();
    gsapWithCSS.set(path, {
      "stroke-dasharray": pathLength,
      "stroke-dashoffset": pathLength
    });
  });
};
const BRAND = () => {
  mainSlider();
};
const recommend = document.querySelector(".recommend");
const RECOMMEND = () => {
  setReviewStars(recommend, setSlider);
};
const setSlider = () => {
  const slider2 = recommend.querySelector(".js-slider");
  const slide = new Splide(slider2, {
    type: "loop",
    speed: 680,
    arrows: true,
    pagination: true,
    autoplay: false,
    perPage: 5,
    perMove: 5,
    // gap: '2vw',
    slideFocus: true,
    pauseOnHover: true,
    width: "100%",
    drag: true,
    rewindByDrag: true,
    pauseOnHover: true,
    keyboard: true,
    wheel: false,
    lazyLoad: "sequential",
    grid: {
      rows: 1,
      cols: 1,
      gap: {
        row: 50,
        col: 50
      }
    },
    breakpoints: {
      [conf.MQ_DOWN.md]: {
        perPage: 1,
        perMove: 1,
        width: "89.33vw",
        fixedWidth: "89.33vw",
        grid: {
          rows: 2,
          cols: 2,
          gap: {
            row: "10.67vw",
            col: "4vw"
          }
        }
      }
    }
  });
  slide.on("pagination:mounted", function (data) {
    data.items.forEach(function (item) {
      item.li.classList.add("paginationWrapper");
      item.button.classList.add("paginationButton");
      item.button.innerHTML = `<svg width="6" height="6" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="5" height="5" rx="2.5" fill="white" stroke="#D9D9D9"/>
      </svg>
      `;
    });
  });
  slide.mount({ Grid });
};
document.addEventListener("DOMContentLoaded", () => {
  KV();
  TOPICS();
  BRAND();
  RECOMMEND();
});
const hoverLink = () => {
  const hasHover = window.matchMedia("(hover: hover)").matches;
  if (!hasHover)
    return;
  class hoverLineClass {
    constructor(el) {
      __publicField(this, "isPlaying");
      __publicField(this, "isHover");
      __publicField(this, "el");
      __publicField(this, "line");
      this.isPlaying = false;
      this.isHover = false;
      this.el = el;
      const line = document.createElement("span");
      line.classList.add("js-linkBar");
      this.el.prepend(line);
      this.line = line;
      gsapWithCSS.set(this.el, {
        position: "relative"
      });
      gsapWithCSS.set(this.line, {
        transformOrigin: "left center",
        scaleX: 0,
        position: "absolute",
        bottom: "-2px",
        left: 0,
        width: "100%",
        height: "2px",
        display: "block",
        backgroundColor: "#000"
      });
      this.el.addEventListener("mouseenter", () => {
        this._eRollOver();
      });
      this.el.addEventListener("mouseleave", () => {
        this._eRollOut();
      });
    }
    _eRollOver() {
      this.isHover = true;
      if (!this.isPlaying) {
        this._startRollOverMotion();
      }
    }
    _startRollOverMotion() {
      this.isPlaying = true;
      gsapWithCSS.to(this.line, {
        transformOrigin: "left center",
        scaleX: 1,
        duration: 0.48,
        ease: "power2.inOut",
        onComplete: () => {
          gsapWithCSS.set(this.line, {
            transformOrigin: "right center"
          });
          this._eCompleteRollOver();
        }
      });
    }
    _eCompleteRollOver() {
      this.isPlaying = false;
      if (!this.isHover) {
        this._eRollOut();
      }
    }
    _eRollOut() {
      this.isHover = false;
      if (!this.isPlaying) {
        this._startRollOutMotion();
      }
    }
    _startRollOutMotion() {
      this.isPlaying = true;
      gsapWithCSS.to(this.line, {
        scaleX: 0,
        duration: 0.32,
        onComplete: () => {
          gsapWithCSS.set(this.line, {
            transformOrigin: "left center"
          });
          this._eCompleteRollOut();
        }
      });
    }
    _eCompleteRollOut() {
      this.isPlaying = false;
      if (this.isHover) {
        this._eRollOver();
      }
    }
  }
  document.querySelectorAll(".js-hoverLink").forEach((el) => {
    new hoverLineClass(el);
  });
};
const hoverTextLink = () => {
  const hasHover = window.matchMedia("(hover: hover)").matches;
  if (!hasHover)
    return;
  class hoverLineTextClass {
    constructor(el) {
      __publicField(this, "isPlaying");
      __publicField(this, "isHover");
      __publicField(this, "el");
      __publicField(this, "line");
      this.isPlaying = false;
      this.isHover = false;
      this.el = el;
      this.text = el.querySelector(".js-text");
      const line = document.createElement("span");
      line.classList.add("js-linkBar");
      this.text.prepend(line);
      this.line = line;
      gsapWithCSS.set(this.text, {
        position: "relative"
      });
      gsapWithCSS.set(this.line, {
        transformOrigin: "left center",
        scaleX: 0,
        position: "absolute",
        bottom: "-1px",
        left: 0,
        width: "100%",
        height: "1px",
        display: "block",
        backgroundColor: "#000"
      });
      this.el.addEventListener("mouseenter", () => {
        this._eRollOver();
      });
      this.el.addEventListener("mouseleave", () => {
        this._eRollOut();
      });
    }
    _eRollOver() {
      this.isHover = true;
      if (!this.isPlaying) {
        this._startRollOverMotion();
      }
    }
    _startRollOverMotion() {
      this.isPlaying = true;
      gsapWithCSS.to(this.line, {
        transformOrigin: "left center",
        scaleX: 1,
        duration: 0.42,
        ease: "power2.inOut",
        onComplete: () => {
          gsapWithCSS.set(this.line, {
            transformOrigin: "right center"
          });
          this._eCompleteRollOver();
        }
      });
    }
    _eCompleteRollOver() {
      this.isPlaying = false;
      if (!this.isHover) {
        this._eRollOut();
      }
    }
    _eRollOut() {
      this.isHover = false;
      if (!this.isPlaying) {
        this._startRollOutMotion();
      }
    }
    _startRollOutMotion() {
      this.isPlaying = true;
      gsapWithCSS.to(this.line, {
        scaleX: 0,
        duration: 0.32,
        onComplete: () => {
          gsapWithCSS.set(this.line, {
            transformOrigin: "left center"
          });
          this._eCompleteRollOut();
        }
      });
    }
    _eCompleteRollOut() {
      this.isPlaying = false;
      if (this.isHover) {
        this._eRollOver();
      }
    }
  }
  document.querySelectorAll(".js-hoverLinkText").forEach((el) => {
    new hoverLineTextClass(el);
  });
};
hoverLink();
hoverTextLink();
